import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=0c188caf&"
import script from "./FacebookIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports